import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { observer, useLocalObservable } from 'mobx-react';
import { useStores } from '../../hooks/use-stores';
import {
    Block,
    FlexDiv,
    Heading1,
    TextDefault,
    TextTiny,
    TextInput,
    ThemedButton,
} from '@awarego-ui/components';
import ErrorMessage from '../../components/errormessage';
import SignUpFormDef from '../../forms/auth';
import { querystring } from '../../utils/helpers';
import TermsOfService from '../../components/TermsOfService';

function SignIn({ company_id, campaign_id, subject_id }) {
    const { authStore, brandingStore, store } = useStores();
    let navigate = useNavigate();

    const localStore = useLocalObservable(() => {
        let signInForm = new SignUpFormDef(
            {},
            {
                hooks: {
                    onSuccess() {
                        handleSubmit();
                    },
                },
            }
        );
        signInForm.observe({
            path: 'managerEmail',
            key: 'value',
            call: ({ form }) => {
                form.validate();
            },
        });

        return { signInForm };
    });

    useEffect(() => {
        authStore.suggestTrial = false;
        const expired = querystring('expired', window.location.search);
        if (expired === '1') {
            authStore.setExtraMessage(
                authStore.emailLoginError ||
                    "Your link is expired, but don't worry we sent a new one."
            );
        }
    }, []);

    const handleSubmit = async () => {
        let redirect = querystring('redirect') || '/';
        authStore.setEmail(localStore.signInForm.$('managerEmail').value);
        authStore.setExtraMessage('Please verify your email.');
        const companyId = company_id || store.companyId || parseInt(window.localStorage.getItem('companyId'));
        const result = await authStore.signin(
            localStore.signInForm.$('managerEmail').value,
            companyId,
            campaign_id,
            subject_id,
            redirect
        );
        if (result === 'redirect') return;
        if (result === 'form') return;
        if (result) navigate('/auth/check-email?utm_term=login');
    };

    const { loginError, emailLoginError, suggestTrial, extraMessage } =
        authStore;
    const { account_name, termsUrl } = brandingStore;

    const inputHasError =
        localStore.signInForm.$('managerEmail').error &&
        localStore.signInForm.$('managerEmail').error.length > 0;

    return (
        <FlexDiv justifyCenter alignCenter wrapper column>
            {(loginError && loginError.length > 0 && (
                <ErrorMessage error={loginError} />
            )) ||
                (emailLoginError && (
                    <ErrorMessage error={emailLoginError} />
                )) ||
                (extraMessage && (
                    <ErrorMessage
                        error={extraMessage}
                        errorType="info"
                    />
                ))}
            <Block width={570}>
                <Heading1>Sign in</Heading1>
                <FlexDiv mb={24}>
                    <TextDefault lighter mr={4}>
                        Don't have an account?
                    </TextDefault>
                    <TextDefault themed bold>
                        <Link to={`/auth/signup`}>Sign up</Link>
                    </TextDefault>
                </FlexDiv>
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        localStore.signInForm.submit();
                    }}
                >
                    <FlexDiv column gap={8}>
                        <TextInput
                            error={inputHasError}
                            helperText={
                                inputHasError ? (
                                    'Please enter your work email'
                                ) : suggestTrial ? (
                                    <TextTiny themed>
                                        The email is not registered in our
                                        system. Would you like to{' '}
                                        <Link to={'/auth/signup'}>
                                            <TextTiny themed bold underline>
                                                sign up
                                            </TextTiny>
                                        </Link>
                                        ?
                                    </TextTiny>
                                ) : undefined
                            }
                            stretched
                            {...localStore.signInForm.$('managerEmail').bind()}
                        />
                        <ThemedButton
                            mode="primary"
                            size="fullWidth"
                            text="Continue"
                            type="submit"
                        />
                        <TermsOfService
                            accountName={account_name}
                            termsUrl={termsUrl}
                        />
                    </FlexDiv>
                </form>
            </Block>
        </FlexDiv>
    );
}

export default observer(SignIn);
